var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-loading d-flex justify-content-center align-items-center"},[_c('b-spinner',{staticClass:"loading text-muted",attrs:{"label":_vm.$t('loading')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }